// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from "react";
import Search from "./search/Search";
import { facetConfiguration } from "./search/configuration";
import S3 from 'aws-sdk/clients/s3';
import AWS from 'aws-sdk';
import aws_exports from './aws-exports';
import Kendra from 'aws-sdk/clients/kendra';
import Auth from '@aws-amplify/auth';
import { AuthState, UI_AUTH_CHANNEL, AUTH_STATE_CHANGE_EVENT } from '@aws-amplify/ui-components';
import { AmplifyGreetings, AmplifySignIn, AmplifyAuthenticator } from '@aws-amplify/ui-react';
import { Hub } from "@aws-amplify/core";
import Button from 'react-bootstrap/Button';
import searchlogo from './searchConsoleArt.svg'
//import credentials from './services/local-dev-credentials.json';

import "./App.css";

const indexId = process.env.REACT_APP_INDEX_ID!;
const region = process.env.REACT_APP_REGION!;
const role_arn = process.env.REACT_APP_ROLE_ARN!;
const enable_auth = process.env.REACT_APP_ENABLE_AUTH!;
const enable_guest = process.env.REACT_APP_ENABLE_GUEST!;
const enable_tokens = process.env.REACT_APP_ENABLE_ACCESSTOKENS!;

interface AppState {
  infraReady: boolean;
  loginScreen: boolean;
  authUser: boolean;
  kendra?: Kendra;
  s3?: S3;
  user?: string;
  accessToken?: string;
}

class App extends React.Component<string[], AppState> {
  constructor(props: string[]) {
    super(props);
    this.state = {
      infraReady: false,
      loginScreen: true,
      authUser: true,
      kendra: undefined,
      s3: undefined,
      user: undefined,
      accessToken: undefined
    };
  }

  handleClick = async () => {
    this.setState({authUser: !this.state.authUser});
  }

  authChangeState = async (nextAuthState: AuthState) => {
    try {
      let user = await Auth.currentAuthenticatedUser();
      //accessToken contains all the information about username, groupname etc.
      let accessToken = user.signInUserSession.accessToken.jwtToken;
      if (nextAuthState === AuthState.SignedIn){
        this.setState({loginScreen:false, authUser: true, user: user ? user!.username : undefined, accessToken: accessToken ? accessToken : undefined});
      } else if (nextAuthState === AuthState.VerifyContact){
        Hub.dispatch(UI_AUTH_CHANNEL, {
          event: AUTH_STATE_CHANGE_EVENT,
          message: AuthState.SignedIn,
          data: await Auth.currentAuthenticatedUser(),
        });
        this.setState({loginScreen:true, authUser: true, user: user ? user!.username : undefined, accessToken: accessToken ? accessToken : undefined});
      } else {
        this.setState({loginScreen:true, authUser: true, user: user ? user!.username : undefined, accessToken: accessToken ? accessToken : undefined});
      }
    } catch {
      console.log('currentAuthenticatedUser Exception');
      if (nextAuthState === AuthState.SignedIn){
        this.setState({loginScreen:false, authUser: true, user: undefined, accessToken: undefined});
      } else if (nextAuthState === AuthState.VerifyContact){
        Hub.dispatch(UI_AUTH_CHANNEL, {
          event: AUTH_STATE_CHANGE_EVENT,
          message: AuthState.SignedIn,
          data: await Auth.currentAuthenticatedUser(),
        });
        this.setState({loginScreen:true, authUser: true, user: undefined, accessToken: undefined});
      } else {
        this.setState({loginScreen:true, authUser: true, user: undefined, accessToken: undefined});
      }
    }
  }

  setInfra(accessKeyId:string, secretAccessKey:string, sessionToken:string) {
    let sts = new AWS.STS({
      accessKeyId: accessKeyId,
      secretAccessKey: secretAccessKey,
      sessionToken: sessionToken,
      region: region
    });
    let sts_params = {
      RoleArn: role_arn,
      RoleSessionName:"wapp"+ Date.now(),
      DurationSeconds:3600
    };
    //Make a call to assume the role to access Kendra and corresponding S3 objects
    sts.assumeRole(sts_params, (err, data) => {
      if (err) console.log("sts_assumerole Error:", err);
      else {
        let kendra = new Kendra({
          accessKeyId: data.Credentials!.AccessKeyId,
          secretAccessKey: data.Credentials!.SecretAccessKey,
          sessionToken: data.Credentials!.SessionToken,
          region: "us-east-1"
        });
        //S3 is required to get signed URLs for S3 objects
        let s3 = new S3({
          accessKeyId: data.Credentials!.AccessKeyId,
          secretAccessKey: data.Credentials!.SecretAccessKey,
          sessionToken: data.Credentials!.SessionToken,
          region: region
        });
        //Call setState to enforce render being called again
        console.log("kendra results, ", kendra);
        this.setState({
          infraReady: true,
          kendra: kendra,
          s3: s3
        });
      }
    });
  }

  async componentDidMount() {
    Auth.configure(aws_exports);
    try {
      let credentials = await Auth.currentUserCredentials();
      //Use Cognito Credentials either authorized or unauthorized to get temporary credentials for Kendra
      this.setInfra(credentials.accessKeyId, credentials.secretAccessKey, credentials.sessionToken);
    } catch (e) {
      console.log("Auth exception: ", e);
    }
  }

  render() {
        return (
          <div className="App">
            {this.state.authUser && (enable_auth === 'true') && (
              <div style={{textAlign: 'left'}}>
              {this.state.loginScreen && (enable_guest === 'true') && (
                <div style={{display: 'flex', justifyContent: 'center'}}>
                  <Button as="input" type="submit" value="Continue as Guest" onClick={this.handleClick} block/>
                </div>
              )}
                <div style={this.state.user ? {} : {display: 'flex', justifyContent: 'center'}}>
                  <AmplifyAuthenticator handleAuthStateChange={this.authChangeState}>
                    <AmplifySignIn slot="sign-in" hideSignUp />
                    <AmplifyGreetings username={this.state.user} slot="greetings"/>
                    {this.state.user && this.state.infraReady && this.state.s3 && (enable_tokens === 'true') &&
                      <Search kendra={this.state.kendra} indexId={indexId} s3={this.state.s3} accessToken={this.state.accessToken} facetConfiguration={facetConfiguration}/>
                    }
                    {this.state.user && this.state.infraReady && this.state.s3 && (enable_tokens === 'false') &&
                      <Search kendra={this.state.kendra} indexId={indexId} s3={this.state.s3} facetConfiguration={facetConfiguration}/>
                    }
                  </AmplifyAuthenticator>
                </div>
              </div>
            )}
            {!this.state.authUser && this.state.infraReady && this.state.s3 && (
            <div>
              {this.state.loginScreen && (enable_guest === 'true') && (
                <div style={{display: 'flex', justifyContent: 'center'}}>
                  <Button as="input" type="submit" value="Welcome Guest! Click here to sign up or sign in" onClick={this.handleClick} block/>
                </div>
              )}
              <Search kendra={this.state.kendra} indexId={indexId} s3={this.state.s3} facetConfiguration={facetConfiguration}/>
            </div>
            )}
            {(enable_auth === 'false') &&  (
              <div className="App">
                <div style={{textAlign: 'center', paddingTop: '50px'}}>
                <svg width="280" height="55" viewBox="0 0 280 55" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="title"><title id="title">Audacy Brand</title><path d="M140.988 24.131v21.48h-6.935v-3.3c-2.549 2.437-6.41 3.749-10.908 3.749-8.322 0-12.97-4.31-12.97-12.033v-9.896h6.935v8.922c0 5.398 2.511 7.947 7.872 7.947 5.698 0 9.071-2.737 9.071-9.56v-7.309h6.935Zm36.382-5.585V45.61h-6.934v-2.736c-2.399 2.062-6.036 3.186-10.834 3.186-9.146 0-14.919-4.049-14.919-10.946 0-6.972 5.848-11.433 14.657-11.433 4.76 0 8.584 1.312 11.096 3.674v-8.81h6.934Zm-6.934 16.306c0-3.936-3.337-6.11-9.409-6.11-6.073 0-9.409 2.174-9.409 6.11 0 3.936 3.336 6.148 9.409 6.148 6.035 0 9.409-2.212 9.409-6.148Zm41.197-2.924V45.61h-6.373v-3.448c-2.699 2.661-6.372 3.898-12.032 3.898-7.873 0-11.921-2.362-11.921-6.897 0-4.386 3.899-6.485 13.045-6.935l10.908-.562c-.187-1.95-2.849-2.924-7.984-2.924-5.435 0-9.671 1.124-13.757 3.673l-.113-.075v-5.81c4.199-1.987 8.997-2.849 14.32-2.849 9.334 0 13.907 2.7 13.907 8.247Zm-6.373 4.273v-.337l-11.808.637c-3.486.188-5.173.938-5.173 2.362 0 1.462 1.612 2.137 5.736 2.137 6.934 0 11.245-1.875 11.245-4.799Zm26.503-12.52c4.724 0 8.847.937 12.708 2.924v6.298l-.15.037c-3.561-2.474-7.422-3.898-12.558-3.898-6.147 0-9.446 2.024-9.446 5.848 0 3.823 3.299 5.81 9.446 5.81 5.136 0 9.034-1.387 12.558-3.861l.15.037v6.26c-3.861 1.987-7.984 2.924-12.708 2.924-10.271 0-16.381-4.386-16.381-11.17 0-6.823 6.11-11.209 16.381-11.209Zm48.237.6-15.669 25.116c-2.512 4.048-5.398 5.66-10.458 5.66h-1.575v-5.06l.225-.15h.75c3.411 0 4.498-.788 6.11-3.487l.432-.72-14.039-21.359.112-.15h7.722l9.671 15.07 9.334-15.07h7.272l.113.15Zm-177.831 21.33h7.647l-16.38-27.065h-7.348L69.707 45.61h7.647l3.23-5.435H98.94l3.229 5.435ZM83.858 34.663l5.904-9.936 5.903 9.936H83.858ZM27.064 31.973c0 7.473-6.058 13.532-13.532 13.532C6.06 45.505 0 39.446 0 31.972 0 24.5 6.059 18.44 13.532 18.44c7.474 0 13.532 6.059 13.532 13.532ZM33.633 0H14.314l24.413 45.61h19.318L33.632 0Z" fill="#ffffff"></path></svg>
                  {/* <img src={searchlogo} alt='Search Logo' /> */}
                </div>
                <Search kendra={this.state.kendra} indexId={indexId} s3={this.state.s3} facetConfiguration={facetConfiguration}/>
             </div>
            )}
          </div>
        );
  }
}

export default App;
